<template>
    <div class="totem-standard-ribbon" :class="ribbon.color" v-if="showRibbon">
        <span v-html="ribbon.name"></span>
    </div>
</template>

<script>
    export default {
        props: {
            ribbon: {
                validator: (value) => {
                    return value.color && [
                        'favourite',
                        'topical',
                        'customer',
                        'free',
                        'unavailable',
                        'new',
                        'upcoming',
                        'expiring',
                        'live',
                        'free',
                        'promotional',
                        'signed'
                    ].includes(value.color)
                }
            },
        },
        computed: {
            showRibbon () {
                return this.ribbon && this.ribbon.name && this.ribbon.name.length > 0
            }
        }
    }
</script>

<style lang="scss">
    .totem-standard-ribbon {
        display: inline-flex;
        align-items: center;
        padding: 0 12px;
        margin: 0 6px 6px 0;
        border-radius: 3px;
        height: 22px;
        background: $bright_gray;
        position: relative;
        font-size: 1.4rem;

        &.unavailable {
            background: $black;
            color: $white;
        }

        &.new {
            background: $fringy_flower;
        }

        &.upcoming {
            background: $tequila;
        }

        &.expiring {
            background: $azalea;
        }

        &.signed {
            padding: 0 12px 0 32px;
            &:before {
                content: '\ea10';
                position: absolute;
                left: 12px;
                font-family: 'icomoon';
                color: $ocean_green;
            }
        }

        &.live {
            padding: 0 12px 0 32px;
            &:before {
                content: '\e94d';
                font-family: icomoon;
                position: absolute;
                left: 12px;
                color: $crimson;
            }
        }
    }
</style>
